import { DomainStoreType } from '@vista-digital/occ-domain'
import { createDomainStore } from '@vista-digital/occ-domain/src/lib/storage/create-domain-store'
import type { CinemaGroup } from '../models/cinemaGroup.models'

interface CinemaGroupDomainStore {
    selected: CinemaGroup | null
}

export const cinemaGroupDomain = createDomainStore<CinemaGroupDomainStore>({
    type: DomainStoreType.BrowserLocal,
    defaultState: { selected: null },
    name: 'cinema-group-domain-store',
})
